import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import InputTcDetails from "./product-details/input-tc-details";
import InputTcProductDetails from "./product-details/input-tc-product-details";
import InputTcProductAdditionalDetails from "./product-details/input-tc-product-additional-details";
import RawMaterialDetails from "./product-details/raw-material-details";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../shared/components/stepper/steppers";
import { ITcProductRawMaterialInformation } from "../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto";
import {
  IInputTcDetails,
  IInputTcProductStandardDetails,
  OCSFirstProcessorData,
} from "../../../tc-models/tc-req-dto/input-tc-product.req_dto";
import InputTcProductStandardDetails from "./product-details/input-tc-product-standard-details";
import OcsProcessor from "./product-details/input-tc-ocs-processor";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../shared/components/buttons/floating-button-container";
import {
  mapPayload,
  reverseMapPayload,
} from "../../payload/input-tc-products-payload";
import { transactionCertificateService } from "../../../tc-service/transaction-certificate.service";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useFormActions } from "../../../../../shared/hooks/form-builder.hooks";
import useNotification from "../../../../../shared/hooks/useNotification";
import { useApi } from "../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import {
  DELETECONFIG,
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../../shared/app-configs/tc-app-configs";
import _, { forEach, isEmpty } from "lodash";
import AlertPopup from "../../../../../shared/components/modals/alert-moadal";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { Utills } from "../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import {
  mapInputTcDataToPostPayload,
  mapPostPayloadToInputTcData,
} from "./input-products.models";
import {
  fetchProductComponentDetails,
  getProductShipmentDataByProductNo,
} from "./input-product-apis";
import { Pagination } from "../../../../../shared/hooks/useRecordStore";

interface InputTcProductDetailProps {
  onNextTab: () => Promise<void>;
}

const InputTcProductDetail: React.FC<InputTcProductDetailProps> = ({
  onNextTab,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const { loading, error, executeGet, executeDelete, executePost } = useApi();
  const { executeGet: executeProduct } = useApi();
  const [data, setData] = useState<any[]>([]);
  const [apiData, setAPIData] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [productId, setProductId] = useState<string | null>(null);
  const [shipmentId, setShipmentId] = useState<string>();
  const [inputTcId, setInputTcId] = useState<string>();
  const [productData, setProductData] = useState<any[]>([]);
  const { TE_ID, formtype } = useParams<string>();
  const [pendingSave, setPendingSave] = useState<any>(null);
  const hasCreateTc: boolean = formtype === "create-tc";
  const hasSubmitTC: boolean = formtype === "submited-tc";
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState<number>(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const [isDeleteOnly, setDeleteOnly] = useState(false);
  const [isValueChanged, setIsValueChanged] = useState<boolean>(false);
  const { isRestrictPopUpSave, setRestrictPopUpSave } =
    useTransactionCertificateStore();
  const [getEditExistingShipment, setEditExistingShipment] = useState({
    index: -1,
    value: "",
  });
  const fetchInputTcProductDetails = async () => {
    try {
      const response: any = await executeGet(
        TCAppConfig.GET_INPUT_TC_PRODUCTDETAILS_INFO,
        { 
          tcId: TE_ID,
          limit: pagination?.pageSize,
          offset: pagination?.pageIndex * pagination?.pageSize
        }
      );
      const result = response.data;
      setTableData(result.response);
      setAPIData(result.data);
      setRowCount(response?.data?.no_of_records);
      setNextEnabled(true);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };
  const shipmentFormData = async () => {
    try {
      const response = await executeProduct(
        TCAppConfig.GET_PRODUCT_RAWMATERIAL_INFO_LIST,
        { tcId: TE_ID }
      );
      setProductData(response?.data.response);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    updateTableRowbyIndex,
    removeTableRowbyIndex,
    updateField,
    resetFormValueByPage,
    setDeleteSave,
    replaceTableDatas,
    getDeleteSave,
    setEditSave,
  } = useFormActions("input-tc-product-details");
  const initInputTcDetails: IInputTcDetails = {
    inputTcNo: "",
    inputTcCBName: "",
    inputTcSellerLicenseNo: "",
    inputTcSellerScNo: "",
    inputTcSellerTeId: "",
    inputTcUsdaCompliantFlag: "",
    inputTcCertifiedWeightUsed: [],
    tcAssociatedProductNo: "",
    InputCBLicensingCode: "",
  };

  const initInputTcProductDetails = {
    inputTcProductNo: "",
    inputTcProductArticleNo: "",
    inputTcProductNumberOfUnits: null,
    inputTcProductUnitsMetric: "",
    inputTcProductProductionDate: "",
    inputTcProductCategoryCode: "",
    inputTcProductCategoryUserSpecificTerm: "",
    inputTcProductDetailCode: "",
    inputTcProductDetailUserSpecificTerm: "",
  };

  const initInputTcProductAdditionalDetails = {
    inputTcProductInfoTrimsExcluded: "",
    inputTcProductInfoAssociatedTc: "",
    inputTcProductInfoFiberLength: "",
    inputTcProductInfoYarnCount: "",
    inputTcProductInfoFabricWeightAndConstruct: "",
    inputTcProductInfoFabricWeightOfFinishedProduct: "",
    inputTcProductInfoAdditional: "",
  };
  const initocsProcessorConfig: OCSFirstProcessorData = {
    inputTcOCSFirstProcessor: "Y",
    tableData: [],
  };
  const initInputTcProductStandardDetails: IInputTcProductStandardDetails[] =
    [];
  const initRawMaterialInfo: ITcProductRawMaterialInformation[] = [];

  const [stepData, setStepData] = useState({
    inputTcDetails: initInputTcDetails,
    ocsProcessorConfig: initocsProcessorConfig,
    inputTcProductDetails: initInputTcProductDetails, //
    inputTcProductAdditionalDetails: initInputTcProductAdditionalDetails, //
    inputTcProductStandardDetails: initInputTcProductStandardDetails,
    rawMaterialDetails: initRawMaterialInfo,
  });

  const toggleDrawer = () => {
    setActiveStep(0);
    if (drawerOpen) {
      setStepData({
        inputTcDetails: initInputTcDetails,
        inputTcProductDetails: initInputTcProductDetails,
        inputTcProductAdditionalDetails: initInputTcProductAdditionalDetails,
        inputTcProductStandardDetails: initInputTcProductStandardDetails,
        rawMaterialDetails: initRawMaterialInfo,
        ocsProcessorConfig: initocsProcessorConfig,
      });
      setProductId(null);
      setShipmentId("");
      setInputTcId("");
      setEditingIndex(-1);
      setZustandInitialState();
      setPendingSave(null);
      setIsValueChanged(false);
    }
    setRestrictPopUpSave(false);
    setDrawerOpen((prev) => !prev);
  };

  const handleConfirmSave = async () => {
    try {
      // If we have a pending save payload, save it first
      if (pendingSave) {
        delete pendingSave.inputTcId;
        await handleSave(pendingSave);
        setPendingSave(null); // Clear the pending save
      }

      // Then delete the existing record
      await executeDelete(`${TCAppConfig.TC_DELETE_API}`, {
        pageName: DELETECONFIG.inputTc,
        tcId: TE_ID,
        inputTcId: inputTcId,
        shipmentId: shipmentId,
        productId: productId,
      });

      // Close the dialog
      setDialogOpen(false);
      fetchInputTcProductDetails();
      // Reset states
      setInputTcId("");
      setShipmentId("");
      setProductId("");

      notify("Successfully processed", "success");
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };

  const handleDeleteSaveData = async () => {
    // Perform API call to save form data here
    try {
      if (TE_ID) {
        if (!isDeleteOnly && getDeleteSave()) {
          const userFilledValues = getCurrentFormValues();
          updateTableRowbyIndex(editingIndex, userFilledValues);
        } else if (isDeleteOnly && !getDeleteSave()) {
          removeTableRowbyIndex(editingIndex);
          const deletedData = data.filter((item, index) => {
            index !== editingIndex;
          });
          setData(deletedData);
          setEditingIndex(-1);
        }
        const tcProductDetailsData = getCurrentTableData();
        setDeleteSave(false);
        setEditSave(false);
        const payload: any = mapPayload(tcProductDetailsData, TE_ID);
        Utills.cl("Form Payload:", JSON.stringify(payload));

        const result: any = await executePost(
          TCAppConfig.INPUT_TCPRODUCT_DETAILS_ENDPOINT,
          payload
        );
        if (result.status == 200) {
          notify("Saved Succesfully", "success");
          if (!isDeleteOnly) toggleDrawer();

          setDeleteOnly(false);
          replaceTableDatas([]);
          await fetchInputTcProductDetails();
        } else {
          notify("Unable to Save", "error");
        }
      }
    } catch (error) {
      console.error("Error saving Transaction Certificate:", error);
    }
  };
  const setZustandInitialState = (initialState?: any) => {
    const defalutState: any = {
      tcAssociatedProductNo: "",
      inputTcNo: "",
      inputTcSellerLicenseNo: "",
      inputTcSellerScNo: "",
      inputTcSellerTeId: "",
      inputTcUsdaCompliantFlag: "",
      inputTcCertifiedWeightUsed: [
        {
          inputTcCertifiedRawMaterialCode: "",
          outputTcCertifiedRawMaterialCode: "",
          inputTcCertifiedRawMaterialWeightUsed: 0,
          inputTcCertifiedRawMaterialCodeDescription: "",
          outputTcCertifiedRawMaterialCodeDescription: "",
        },
      ],

      "input-tc-ocs-processor": [
        {
          inputFarmSCNo: "",
          inputFarmTCNo: "",
          inputTraderTCNoForOrganicMaterial: "",
          inputTCOrganicFarmStandards: "",
          tcProductRawMaterialOrder: 0,
        },
        {
          inputFarmSCNo: "",
          inputFarmTCNo: "",
          inputTraderTCNoForOrganicMaterial: "",
          inputTCOrganicFarmStandards: "",
          tcProductRawMaterialOrder: 0,
        },
      ],
      inputTcProductNo: "",
      inputTcProductArticleNo: "",
      inputTcProductNumberOfUnits: null,
      inputTcProductUnitsMetric: "",
      inputTcProductProductionDate: "",
      inputTcProductCategoryCode: "",
      inputTcProductCategoryUserSpecificTerm: "",
      inputTcProductDetailCode: "",
      inputTcProductDetailUserSpecificTerm: "",
      inputTcProductInfoTrimsExcluded: "",
      inputTcProductInfoAssociatedTc: "",
      inputTcProductInfoFiberLength: "",
      inputTcProductInfoYarnCount: "",
      inputTcProductInfoFabricWeightAndConstruct: "",
      inputTcProductInfoFabricWeightOfFinishedProduct: "",
      inputTcProductInfoAdditional: "",
      "tc-std-info": [
        {
          standardLabelGrade: "",
          certifiedWeight: 0,
          certifiedWeightUsed: 0,
        },
      ],
      "raw-materials-info": [
        {
          tcProductRawMaterialOrder: 0,
          tcProductRawMaterialCode: "",
          tcProductRawMaterialPercentage: 0,
        },
        {
          tcProductRawMaterialOrder: 0,
          tcProductRawMaterialCode: "",
          tcProductRawMaterialPercentage: 0,
        },
      ],
    };

    //set zustand state inital values
    Object.entries(initialState ?? defalutState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };

  useEffect(() => {
    setZustandInitialState(null);
    const componentDetailsData = getCurrentTableData();
    Utills.cl(`componentDetailsData ${componentDetailsData}`);
    if (componentDetailsData) {
      setData(componentDetailsData);
    }
    if (TE_ID) {
      fetchInputTcProductDetails();
      shipmentFormData();
    } else {
      // TO DO Port Changes
      updateTableData([]);
    }
    // TO DO Port Changes
    setRestrictPopUpSave(false);
    resetFormValueByPage();
    setZustandInitialState(null);
  }, [TE_ID, pagination?.pageIndex]);
  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    Utills.cl("updatedData", updatedData);
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };
  const productInfoRef = useRef<any>(null);
  const lastProcessorInfoRef = useRef<any>(null);
  const additionalInfoRef = useRef<any>(null);
  const InfoRef = useRef<any>(null);
  const { notify } = useNotification();
  const formRefs = [
    InfoRef,
    productInfoRef,
    lastProcessorInfoRef,
    additionalInfoRef,
  ];
  const navigate = useNavigate();

  const steps = [
    {
      label: "OCS Processor",
      content: (
        <OcsProcessor
          ocsProcessorData={stepData.ocsProcessorConfig}
          setOcsProcessorData={(data) =>
            handleDataUpdate("ocsProcessorConfig", data)
          }
        />
      ),
    },
    {
      label: "Input TC Details",
      content: (
        <InputTcDetails
          formRef={productInfoRef}
          ocsProcessor={stepData.ocsProcessorConfig.tableData}
          inputData={stepData.inputTcDetails}
          setInputData={(data) => handleDataUpdate("inputTcDetails", data)}
        />
      ),
    },
    {
      label: "Input TC Product Details",
      content: (
        <InputTcProductDetails
          formRef={lastProcessorInfoRef}
          productData={stepData.inputTcProductDetails}
          setProductData={(data) =>
            handleDataUpdate("inputTcProductDetails", data)
          }
        />
      ),
    },
    {
      label: "Input TC Product Additional Details",
      content: (
        <InputTcProductAdditionalDetails
          formRef={additionalInfoRef}
          additionalData={stepData.inputTcProductAdditionalDetails}
          setAdditionalData={(data) =>
            handleDataUpdate("inputTcProductAdditionalDetails", data)
          }
        />
      ),
    },
    {
      label: "Input TC Product Standard Details",
      content: (
        <InputTcProductStandardDetails
          productStandardData={stepData.inputTcProductStandardDetails}
          setProductStandardData={(data) =>
            handleDataUpdate("inputTcProductStandardDetails", data)
          }
        />
      ),
    },
    {
      label: "Raw Material Details",
      content: (
        <RawMaterialDetails
          rawMaterialInfoData={stepData.rawMaterialDetails}
          setRawMaterialInfoData={(data) =>
            handleDataUpdate("rawMaterialDetails", data)
          }
        />
      ),
    },
  ];

  const handleNext = async () => {
    if (formRefs[activeStep]?.current) {
      // Prefer current form value for inputTcNo when determining if raw materials are mandatory
      const currentFormValues = formRefs[activeStep]?.current?.values || {};
      const isInputTcNoNA = (currentFormValues?.inputTcNo ?? stepData?.inputTcDetails?.inputTcNo) === "N/A";
      const noCertifiedWtsInfo = activeStep===1 && !isInputTcNoNA && (isEmpty(stepData?.inputTcDetails?.inputTcCertifiedWeightUsed));
      const errors = await formRefs[activeStep]?.current.validateForm();
      await formRefs[activeStep]?.current.submitForm();
      if (Object.keys(errors).length === 0 && !noCertifiedWtsInfo) {
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
      } else {
        notify("Please Enter the Required Values", "error");
      }
    } else {
      // Step-specific validation logic
      if (activeStep === 0) {
        if (
          stepData?.ocsProcessorConfig?.inputTcOCSFirstProcessor == "N" &&
          stepData.ocsProcessorConfig.tableData.length > 0
        ) {
          stepData.ocsProcessorConfig.tableData = [];
        }
        // Validate ocsProcessorConfig for step 1
        if (
          stepData?.ocsProcessorConfig?.inputTcOCSFirstProcessor &&
          stepData?.ocsProcessorConfig?.inputTcOCSFirstProcessor == "Y"
        ) {
          if (
            stepData?.ocsProcessorConfig?.tableData &&
            Object.keys(stepData?.ocsProcessorConfig?.tableData).length > 0
          ) {
            setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
          } else {
            notify(
              "Please Enter the Required Values for OCS Processor",
              "error"
            );
          }
        } else {
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
        }
      } else {
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
      }
      // else if (activeStep === 4) {
      //   // Validate inputTcProductStandardDetails for step 4
      //   if (
      //     stepData?.inputTcProductStandardDetails &&
      //     stepData?.inputTcProductStandardDetails.length > 0 &&
      //     stepData?.inputTcProductStandardDetails.every((item) => Object.keys(item).length > 0)
      //   ) {
      //     setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
      //   } else {
      //     notify('Please Enter the Required Values for TC Product Standard Details', 'error');
      //   }
      // }
      // else {
      //   // Default behavior for steps without additional validation
      //   setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
      // }
    }
  };

  const mapToTCProductDetails = (jsonData: any): any => {
    const inputTcInfo = jsonData.inputTcInformation[0]; // First (and only) inputTcInformation object
    const inputProduct = inputTcInfo.inputTcProductInformation[0]; // First (and only) product info object
    return {
      inputTcDetails: {
        inputTcNo: inputTcInfo.inputTcNo,
        inputTcSellerLicenseNo: inputTcInfo.inputTcSellerLicenseNo,
        inputTcSellerScNo: inputTcInfo.inputTcSellerScNo,
        inputTcSellerTeId: inputTcInfo.inputTcSellerTeId,
        inputTcUsdaCompliantFlag: inputTcInfo.inputTcUsdaCompliantFlag,
        inputTcCertifiedRawMaterialWeightUsedInformation:
          inputTcInfo.inputTcCertifiedRawMaterialWeightUsedInformation || [],
        tcAssociatedProductNo: inputTcInfo.tcAssociatedProductNo,
        InputCBLicensingCode: inputTcInfo.inputTcCbLicensingCode,
      },

      inputTcProductDetails: {
        inputTcProductNo: inputProduct.inputTcProductNo,
        inputTcProductArticleNo: inputProduct.inputTcProductArticleNo,
        inputTcProductNumberOfUnits: inputProduct.inputTcProductNumberOfUnits,
        inputTcProductUnitsMetric: inputProduct.inputTcProductUnitsMetric,
        inputTcProductProductionDate: inputProduct.inputTcProductProductionDate,
        inputTcProductCategoryCode: inputProduct.inputTcProductCategoryCode,
        inputTcProductCategoryUserSpecificTerm:
          inputProduct.inputTcProductCategoryUserSpecificTerm,
        inputTcProductDetailCode: inputProduct.inputTcProductDetailCode,
        inputTcProductDetailUserSpecificTerm:
          inputProduct.inputTcProductDetailUserSpecificTerm,
      },

      inputTcProductAdditionalDetails: {
        inputTcProductInfoTrimsExcluded:
          inputProduct.inputTcProductInfoTrimsExcluded,
        inputTcProductInfoAssociatedTc:
          inputProduct.inputTcProductInfoAssociatedTc,
        inputTcProductInfoFiberLength:
          inputProduct.inputTcProductInfoFiberLength || "",
        inputTcProductInfoYarnCount:
          inputProduct.inputTcProductInfoYarnCount || "",
        inputTcProductInfoFabricWeightAndConstruct:
          inputProduct.inputTcProductInfoFabricWeightAndConstruct || "",
        inputTcProductInfoFabricWeightOfFinishedProduct:
          inputProduct.inputTcProductInfoFabricWeightOfFinishedProduct || "",
        inputTcProductInfoAdditional: inputProduct.inputTcProductInfoAdditional,
      },

      inputTcProductStandardDetails:
        inputProduct.inputTcProductStandardInformation.map((item: any) => ({
          standardLabelGrade: item.inputTcProductStandardLabelGrade,
          certifiedWeight: item.inputTcProductCertifiedWeight,
          certifiedWeightUsed: item.inputTcProductCertifiedWeightUsed,
        })),

      rawMaterialDetails: inputProduct.inputProductRawMaterialInformation.map(
        (item: any) => ({
          tcProductRawMaterialCode: item.inputTcProductRawMaterialCode,
          tcProductRawMaterialPercentage:
            item.inputTcProductRawMaterialPercentage,
          tcProductRawMaterialOrder:
            item.inputProductRawMaterialInformationOrder,
        })
      ),

      ocsProcessorConfig: {
        inputTcOCSFirstProcessor: inputTcInfo.ocsProcessor || "N",
        tableData: inputTcInfo.inputFarmTraderOrganicInformation.map(
          (item: any) => ({
            inputFarmSCNo: item.inputFarmScNo,
            inputFarmTCNo: item.inputFarmTcNo,
            inputTraderTCNoForOrganicMaterial:
              item.inputTraderTcNoForOrganicMaterial,
            inputTCOrganicFarmStandards: item.inputTcOrganicFarmStandards,
            tcProductRawMaterialOrder:
              item.inputFarmTraderOrganicInformationOrder,
          })
        ),
      },
    };
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
    setRestrictPopUpSave(false);
  };

  const handleFinish = async () => {
    if (TE_ID) {
      const payload = mapPayload(stepData, TE_ID, inputTcId);

      // Check if inputTcNo exists and has changed
      if (inputTcId) {
        // Find the existing record in tableData that matches the inputTcId
        const existingRecord = tableData.find(
          (item) => item.inputTcId === inputTcId
        );

        // If record exists and inputTcNo has changed, handle deletion
        if (
          existingRecord &&
          payload.inputTcInformation[0].inputTcProductInformation[0]
            .inputTcProductNo &&
          existingRecord.inputTcProductNo !==
            payload?.inputTcInformation[0]?.inputTcProductInformation[0]
              ?.inputTcProductNo
        ) {
          const row = {
            original: {
              inputTcNo:
                payload.inputTcInformation[0].inputTcProductInformation[0]
                  .inputTcProductNo,
              inputTcId: inputTcId,
              shipmentId: shipmentId,
              productId: productId,
            },
          };
          const isAssociatedProductChanged =
            existingRecord &&
            !_.isEqual(
              existingRecord.tcAssociatedProductNo,
              payload.inputTcInformation[0].tcAssociatedProductNo
            );
          setIsValueChanged(isAssociatedProductChanged || false);
          await handleEditDelete(row);
          // The actual save will happen in the handleConfirmSave after deletion
          setPendingSave(payload);
          return;
        }

        // If it's a new component or no changes to component number, save directly
        handleSave(payload);
      } else if (!inputTcId) {
        // This is a new component, not an edit
        handleSave(payload);
      }
    }
  };

  const handleEdit = (row: any) => {
    // Extract the component data from the row
    const value = row?.original;
    setShipmentId(value.shipmentId);
    setProductId(value.productId);
    setInputTcId(value.inputTcId);
    // Set the productId in state
    console.log(value);
    // Check if the TC ID (TE_ID) exists before fetching details
    if (TE_ID) {
      fetchProductComponentDetails(
        executeGet, // API executor function
        TE_ID, // tcId: using TE_ID
        value.shipmentId, // shipmentId from the component data
        value.productId, // productId from the component data
        value.inputTcId // inputTcId: mapping from componentId
      )
        .then((data) => {
          console.log("EDIT", data);

          // const productList = data?.data?.tcComponentInformation;

          //           if (productList && productList.length > 0) {
          //             const product = productList[0];
          //             console.log('product',product)
          const mappedStepData = mapToTCProductDetails(data.data);
          //             console.log('mappedStepData',mappedStepData)
          console.log("mappedStepData", mappedStepData);
          setStepData(mappedStepData);
          //           }
          toggleDrawer();
        })
        .catch((err) => {
          // Update error state and optionally notify the user
          notify(err.message, "error");
        });
    }

    // Update additional state for editing context
    setEditingIndex(row.index);
    setZustandInitialState(value);
  };

  const handleDelete = (row: any) => {
    setInputTcId(row?.original?.inputTcId);
    setShipmentId(row?.original?.shipmentId);
    setProductId(row?.original?.productId);

    setDialogOpen(true);
    setPopUpBtnName("Delete");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(
      `Deleting a Product will remove all the Associated Records, are you sure want to delete it`
    );
  };
  const handleEditDelete = (row: any) => {
    setInputTcId(row?.original?.inputTcId);
    setShipmentId(row?.original?.shipmentId);
    setProductId(row?.original?.productId);

    setDialogOpen(true);
    setPopUpBtnName("Save");
    setPopUpTitle("Confirm Save");
    setPopUpMessage(
      `Editing a Product No. will remove all the Associated Records, are you sure you want to edit it?`
    );
  };

  const certifiedWeightCell = ({ cell }: { cell: any }) => {
    const weightUsed = cell.getValue() as any;
    if (weightUsed?.length > 1) {
      const formattedVals = weightUsed.map((num: any) => {
        if (!isNaN(parseFloat(num)) && isFinite(Number(num))) {
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(Number(num));
        }
        return num;
      });
      const result = formattedVals.join(", ");
      return result;
    } else {
      if (!isNaN(parseFloat(weightUsed)) && parseFloat(weightUsed) > 0) {
        return new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(parseFloat(weightUsed));
      }
      return weightUsed;
    }
  };

  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "inputTcNo",
      header: "Input TC No.",
      minSize: 60,
      maxSize: 100,
    },
    {
      accessorKey: "tcAssociatedProductNo",
      header: "Associated Product No.",
      minSize: 60,
      maxSize: 100,
    },
    {
      accessorKey: "inputTcSellerLicenseNo",
      header: "Seller License No.",
      minSize: 60,
      maxSize: 100,
    },
    {
      accessorKey: "inputTcSellerScNo",
      header: "Seller SC No.",
      minSize: 60,
      maxSize: 100,
    },
    {
      accessorKey: "inputTcSellerTeId",
      header: "Input TC Seller TE-ID",
      minSize: 60,
      maxSize: 100,
    },
    {
      accessorKey: "inputTcUsdaCompliantFlag",
      header: "USDA Compliance",
      minSize: 60,
      maxSize: 100,
    }
  ];

  const onNext = () => {
    navigate(`/tc/${formtype}/Input-tc-component/${TE_ID}`);
  };

  const handleSave = async (payload: any) => {
    if (!TE_ID) {
      return;
    }
    const paramData = getProductShipmentDataByProductNo(
      productData,
      payload.inputTcInformation[0].tcAssociatedProductNo
    );
    const queryParams = new URLSearchParams({
      tcId: TE_ID,
      shipmentId: JSON.stringify(paramData?.shipmentId) || "",
      productId: paramData?.productId || "",
    }).toString();

    const oldProductIdArray = productId ? productId : paramData?.productId;
    const oldShipmentIdArray = shipmentId
      ? [shipmentId]
      : paramData?.shipmentId;
    const oldProductIdParam = JSON.stringify(oldProductIdArray);
    const oldShipmentIdParam = JSON.stringify(oldShipmentIdArray);

    const finalUrl = `${TCAppConfig.INPUT_TCPRODUCT_DETAILS_ENDPOINT}?${queryParams}&oldProductId=${oldProductIdArray}&oldShipmentId=${oldShipmentIdParam}`;

    const result: any = await executePost(finalUrl, payload);
    if (result.status == 200) {
      notify("Data Saved Successfully", "success");
      setInputTcId("");
      setShipmentId("");
      setProductId("");
      fetchInputTcProductDetails();
      setStepData({
        inputTcDetails: initInputTcDetails,
        inputTcProductDetails: initInputTcProductDetails,
        inputTcProductAdditionalDetails: initInputTcProductAdditionalDetails,
        inputTcProductStandardDetails: initInputTcProductStandardDetails,
        rawMaterialDetails: initRawMaterialInfo,
        ocsProcessorConfig: initocsProcessorConfig,
      });

      toggleDrawer();
      await onNextTab();
    } else {
      notify("Unable to Save", "error");
    }
  };
  const handleCancelSave = () => {
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };

  const actions: ActionButtonConfig[] = [
    ...activeStep!==0?[{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as "contained",
      color: "default" as "default",
      disabled: activeStep === 0,
    }]:[],
    {
      label: activeStep === steps.length - 1 ? "Save" : "Next",
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained" as "contained",
      color: "primary" as "primary",
      disabled: activeStep === 0 ||activeStep === 1 || activeStep===4 || activeStep===5 ? isRestrictPopUpSave : false,
    },
  ];
  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!hasSubmitTC && (
              <StyledButton variant="contained" onClick={toggleDrawer}>
                Add Input TC Details
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              rowCount={rowCount}
              paginations={pagination}
              setPaginations={setPagination}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!hasSubmitTC}
              renderRowActions={({ row }) => (
                <ActionsMenu
                  row={row}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                />
              )}
              renderDetailPanel={({ row }) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>NO data</>
                )
              }
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title="Input TC Product Details"
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step) => setActiveStep(step)}
            />
          </ActionsModalPopup>
          {!drawerOpen ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                gap: "0.5rem",
              }}
            >
              <NavLink to="/tc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              {/* {!isNextEnabled && <InnerButton onClick={handleSave}>Save & Next</InnerButton>= */}
              {tableData?.length > 0 && isNextEnabled && (
                <InnerButton onClick={onNext}>Next</InnerButton>
              )}
            </Box>
          ) : (
            <>
              {hasSubmitTC && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                    gap: "0.5rem",
                  }}
                >
                  <NavLink to={`/tc/${formtype}/component-details/${TE_ID}`}>
                    <InnerButton>Back</InnerButton>
                  </NavLink>
                  <InnerButton onClick={onNext}>Next</InnerButton>
                </Box>
              )}
            </>
          )}

          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default InputTcProductDetail;
